import { render, staticRenderFns } from "./MessageContentFile.vue?vue&type=template&id=f7b772f2&scoped=true"
import script from "./MessageContentFile.vue?vue&type=script&lang=js"
export * from "./MessageContentFile.vue?vue&type=script&lang=js"
import style0 from "./MessageContentFile.vue?vue&type=style&index=0&id=f7b772f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b772f2",
  null
  
)

export default component.exports